import { useMemo } from "react";
import { useChannels } from "@/features/chat/hooks/useChannels";
import { CLASSIFIED_AD_CONTEXT_TYPE, isClassifiedAdContextType } from "@/features/chat/utils/classifiedAdContext";

type ClassifiedAdUnreadCounts = {
  totalUnreadRooms: number
  getUnreadCountForAd: (adId: string) => number
  isLoading: boolean
};

export const useClassifiedAdUnreadCounts = (): ClassifiedAdUnreadCounts => {
  const { data, isLoading } = useChannels({ contextType: CLASSIFIED_AD_CONTEXT_TYPE });

  const { totalUnreadRooms, unreadByAdId } = useMemo(() => {
    const byAdId = new Map<string, number>();
    let total = 0;

    for (const channel of data?.channels ?? []) {
      if (channel.unread_messages_count <= 0) continue;
      if (!isClassifiedAdContextType(channel.context?.type)) continue;

      total += 1;
      const adId = channel.context?.id;
      if (adId) byAdId.set(adId, (byAdId.get(adId) ?? 0) + 1);
    }

    return { totalUnreadRooms: total, unreadByAdId: byAdId };
  }, [data]);

  return {
    totalUnreadRooms,
    getUnreadCountForAd: (adId: string) => unreadByAdId.get(adId) ?? 0,
    isLoading,
  };
};
